import PhtService from 'Services/PhtService'
import OfficeService from 'Services/OfficeService'

export default {

    state: {
        pht: {
            id: null,
            first_name: '',
            last_name: '',
            email: '',
            custom_fields: [],
            hash_code: '',
            portal_identifier: null,
            notification_to_patient_one_day_before_visit: false,
            notification_to_patient_two_days_before_visit: false,
            notification_to_patient_three_days_before_visit: false,
            p1_integration_settings: {
                connection_status: null,
                connection_error_details: null,
                tls_cert_exists: null,
                tls_cert_password: null,
                wss_cert_exists: null,
                wss_cert_password: null,
                oid_node: null,
                entity_type: null,
                location_identifier_type: null,
                location_identifier_value: null,
                integration_enabled: false,
            }
        },
        phtOffices: [],
    },

    getters: {
        pht: state => state.pht,
        phtOffices: state => state.phtOffices,
    },

    mutations: {
        SET_PHT(state, pht) {
            state.pht = pht
        },
        SET_OFFICES(state, offices) {
            state.phtOffices = offices
        },

        MERGE_OFFICES(state, data) {
            //TODO
            state.phtOffices += data
        }
    },

    actions: {
        PHT_FETCH(context) {
            return PhtService.getUser().then(({data}) => {
                context.commit('SET_PHT', data.data)
            })
        },
        PHT_EXT_OFFICES_FETCH(context) {
            return OfficeService.listExternal().then((response) => {
                context.commit('SET_OFFICES', response.data.data)
                return response
            })
        },

        PHT_PASSWORD_RESET(context, data) {
            return PhtService.resetPassword(data)
        },

        PHT_PASSWORD_NEW(context, data) {
            return PhtService.newPassword(data)
        },

        PHT_PASSWORD_UPDATE(context, password) {
            return PhtService.updatePassword(password)
        },

        PHT_P1_INTEGRATION_UPDATE(context, data) {
            return PhtService.updateP1Integration(data).then((response) => {
                context.commit('SET_PHT', response.data.data)
                return response;
            })
        },

        PHT_EXPORT_PATIENT_DOC(context, data) {
            if (!Object.keys(data.query).length)
                data.query = null
            return PhtService.exportPatientDoc(data.patient_id, data.query)
        },

        PHT_TRANSFER_PATIENT_DOC(context, data) {
            return PhtService.transferPatientDoc(data.patient_id, data.pwz)
        },

        PHT_CUSTOM_FIELDS_UPDATE(context) {
            const cf = {
                custom_fields: context.state.pht.custom_fields
            }
            return PhtService.updateCF(cf).then(({data}) => {
                context.commit('SET_PHT', data.data)
            })
        },

        PHT_NOTIFICATIONS_UPDATE(context, notifications) {
            return PhtService.updateNotifications(notifications)
        },

        PHT_OFFICES_FETCH(context) {
            return OfficeService.list().then(({data}) => {
                context.commit('SET_OFFICES', data.data)
            })
        },
        PHT_OFFICE_STORE(context, officeName) {
            const office = {
                name: officeName
            }
            return OfficeService.store(office).then((response) => {
                context.dispatch('PHT_OFFICES_FETCH')
                return response
            })
        },
        PHT_OFFICE_UPDATE(context, office) {
            return OfficeService.update(office.id, office).then((response) => {
                context.dispatch('PHT_OFFICES_FETCH')
                return response
            })
        },
        PHT_OFFICE_REMOVE(context, officeId) {
            return OfficeService.delete(officeId).then((response) => {
                context.dispatch('PHT_OFFICES_FETCH')
                return response
            })
        }
    }

}
